// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__nFkBy","emails":"CreateEditClinics_emails__1SqQ_","emailTagLabel":"CreateEditClinics_emailTagLabel__28ysY"};